import { createSelector } from 'reselect';
import { Map as iMap } from 'immutable';

const brandMetricsByBrandId = (state, brandId) =>
  state.getIn(['brandsCharts', 'brandChartMetrics',String(brandId),'metrics'], iMap()).get(-1);

export const brandMetricsByBrandIdSelector = createSelector(
  [brandMetricsByBrandId],
  (brandMetricsByBrandId) => brandMetricsByBrandId || iMap(),
);